
<div class="container">
    <div class="ticket-container">
          <!-- Header -->
        <div class="page-header">
            <div class="breadcrumb">
                <span class="breadcrumb-item" (click)="goToDashboard()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                    </svg>
                    Dashboard
                </span>
                <span class="breadcrumb-separator">›</span>
                <span class="breadcrumb-item active">Beta Feedback</span>
            </div>
            <button class="btn-back" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                </svg>
                Go Back
            </button>
        </div>
        <!-- Form Section -->
        <div class="form-section">
            <!-- Subject -->
            <!-- <div class="form-group">
                <label class="form-label">Subject<span class="required-star">*</span></label>
                <input type="text" class="form-input" [(ngModel)]="ticketForm.subject" 
                       [class.error]="errors['subject']" placeholder="Enter ticket subject" 
                       maxlength="100" (input)="updateSubjectCount()">
                <div class="error-message" *ngIf="errors['subject']" [class.show]="errors['subject']">
                    {{errors['subject']}}
                </div>
                <div class="char-counter">{{subjectCounter}}</div>
            </div> -->

            <!-- Description -->
            <div class="form-group">
                <label class="form-label">Tell us about your experience <span class="required-star">*</span></label>
                <textarea class="form-textarea" [(ngModel)]="ticketForm.description" 
                          [class.error]="errors['description']" 
                          placeholder="Tell us about your experience ..." 
                          maxlength="500" (input)="updateDescriptionCount()"></textarea>
                <div class="error-message" *ngIf="errors['description']" [class.show]="errors['description']">
                    {{errors['description']}}
                </div>
                <div class="char-counter">{{descriptionCounter}}</div>
            </div>

            <!-- File Upload -->
            <div class="file-upload-section">
                <label class="form-label">Attachments</label>
                
                <div class="uploaded-images" *ngIf="uploadedPreviews.length > 0">
                    <div class="uploaded-image-item" *ngFor="let preview of uploadedPreviews; let i = index">
                        <img [src]="preview" alt="Uploaded image">
                        <button class="remove-image" (click)="removeImage(i)" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                
                <p class="upload-note">Note: You can attach maximum 5 images</p>
                
                <input type="file" id="fileInput" class="file-input-hidden" accept="image/*" 
                       multiple (change)="onFileSelect($event)">
                
                <button class="btn-attach-file" (click)="openFileSelector()" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                    </svg>
                    Attach File
                </button>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
            <button class="btn btn-cancel" (click)="cancel()" type="button">Cancel</button>
            <button class="btn btn-submit" (click)="createTicket()" type="button" [disabled]="isSubmitting">
                <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; margin-right: 6px;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                <svg *ngIf="isSubmitting" class="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" style="width: 18px; height: 18px; margin-right: 6px;">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25;"></circle>
                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" style="opacity: 0.75;"></path>
                </svg>
                {{ isSubmitting ? 'Submitting...' : 'Submit' }}
            </button>
        </div>
    </div>
</div>